import { convertObject, cn } from '@utils/general';
import PropTypes from 'prop-types';
import React from 'react';
import {
  AlertCircle, AlertTriangle, Bell, Calendar, Check, CheckCircle, CheckSquare,
  ChevronDown, ChevronLeft, ChevronRight, ChevronUp, Clock, Cloud, Download, Eye,
  FileText, Folder, HelpCircle, Lock, LogOut, Mail, MessageCircle, MessageSquare,
  MoreVertical, ChevronsDown, Paperclip, Phone, Plus, RefreshCw, RotateCcw, Send, Upload, User, X, XCircle,
} from 'react-feather';
import './icon.scss';

// Explicit icon set — only the icons the app actually renders: statically via `IconKeys.*`
// and dynamically via CHANNEL_ICONS (keys.js) and the file-upload state config
// (services/file-upload-manager.js). Named imports (vs the old `import * as FeatherIcons`)
// let Rollup tree-shake the ~250 unused react-feather icons out of the bundle. When adding a
// new icon anywhere, add it here too.
const FeatherIcons = {
  AlertCircle,
  AlertTriangle,
  Bell,
  Calendar,
  Check,
  CheckCircle,
  CheckSquare,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronsDown,
  ChevronUp,
  Clock,
  Cloud,
  Download,
  Eye,
  FileText,
  Folder,
  HelpCircle,
  Lock,
  LogOut,
  Mail,
  MessageCircle,
  MessageSquare,
  MoreVertical,
  Paperclip,
  Phone,
  Plus,
  RefreshCw,
  RotateCcw,
  Send,
  Upload,
  User,
  X,
  XCircle,
};

export const IconKeys = convertObject(FeatherIcons);

export const IconColors = {
  GRAY: '#667085',
  GRAY_LIGHT: '#98a2b3',
  WHITE: '#fff',
  PRIMARY: '#6941c6',
  PRIMARY_LIGHT: '#9e77ed',
  SUCCESS: '#039855',
  ERROR: '#d92d20',
  WARNING: '#dc6803',
};

export const IconThemes = {
  GRAY: 'gray',
  PRIMARY: 'primary',
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
};

const Icon = ({ iconName, ...props }) => {
  if (FeatherIcons[iconName]) {
    const IconComponent = FeatherIcons[iconName];
    const { isFeatureIcon, ...rest } = props;
    if (isFeatureIcon) {
      return (
        <div className={cn(props.theme, 'relative flex items-center justify-center')}>
          <div className="absolute w-12 h-12 rounded-full bg-x-50" />
          <div className="absolute w-10 h-10 rounded-full opacity-50 bg-x-50" />
          <div className="relative flex items-center justify-center w-8 h-8 rounded-full text-x-500 bg-x-100">
            <IconComponent {...rest} size={props.size} color={IconColors[props.theme]} onClick={props.onClick} className={props.className} />
          </div>
        </div>
      );
    }
    return <IconComponent {...rest} size={props.size} color={props.color} onClick={props.onClick} className={props.className} />;
  }

  console.error(`Icon '${iconName}' not found in ICONS dictionary.`);
  return null;
};

Icon.defaultProps = {
  isFeatureIcon: false,
  color: IconColors.GRAY,
  theme: IconThemes.GRAY,
  size: 20,
  onClick: () => {},
  className: '',
};

Icon.propTypes = {
  iconName: PropTypes.oneOf(Object.keys(IconKeys)).isRequired,
  isFeatureIcon: PropTypes.bool,
  theme: PropTypes.oneOf(Object.values(IconThemes)),
  size: PropTypes.number,
  color: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default Icon;
